import { render, staticRenderFns } from "./dispatch_report.vue?vue&type=template&id=2b5b2303&"
import script from "./dispatch_report.vue?vue&type=script&lang=js&"
export * from "./dispatch_report.vue?vue&type=script&lang=js&"
import style0 from "./dispatch_report.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports